import React from 'react';
import type { TransitionProps } from '../Transition/Transition.types';

export interface CollapseProps {
  /**  Adds a `data-hook` attribute for testing purposes. */
  dataHook?: string;
  /** Determines if the collapse stays fixed at the top of its container.
   *  @default static
   */
  position?: 'static' | 'sticky';
  /**
   * Determines whether the collapse is open.
   * @default true
   */
  open?: boolean;
  /**
   * Delays mounting the component until it is displayed.
   * If `false`, the component mounts immediately. If `true`, it mounts on first display.
   * @default true
   */
  mountOnEnter?: TransitionProps['mountOnEnter'];
  /**
   * Unmounts the component after it finishes exiting. If `false`, the component stays mounted after exit.
   * @default true
   */
  unmountOnExit?: TransitionProps['unmountOnExit'];
  /**
   * Triggered when the expand animation completes.
   */
  onExpandAnimationEnd?: TransitionProps['onStart'];
  /**
   * Triggered when the collapse animation completes.
   */
  onCollapseAnimationEnd?: TransitionProps['onEnd'];
  /**
   * Content to render inside the collapse.
   */
  children?: React.ReactNode;
}
